import { useTranslation } from 'react-i18next';
import LaborRuleBaseConfirmationModal, {
  ConfirmationFormValues,
} from '../LaborRuleBaseConfirmationModal/LaborRuleBaseConfirmationModal';
import { ModalType } from '../../models/LaborRuleConfiguration';

interface TipCreditCalculationModalProps {
  mode: ModalType;
  handleClose: () => void;
  handleAction: (confirmData: ConfirmationFormValues) => Promise<void>;
  loading: boolean;
  furthestAwayWorkWeekDate: string;
}

export default function TipCreditCalculationModal({
  mode,
  handleClose,
  handleAction,
  loading,
  furthestAwayWorkWeekDate,
}: TipCreditCalculationModalProps) {
  const { t } = useTranslation();

  const isEnable = mode === ModalType.TurnOnCalculation;
  const action = isEnable ? 'on' : 'off';
  const subHeaderTextKey = isEnable
    ? 'laborRules.tipCreditCalculationModal.subHeaderTextOn'
    : 'laborRules.tipCreditCalculationModal.subHeaderTextOff';

  const acknowledgementCheckbox = {
    name: isEnable ? 'enableCalculationAcknowledgement' : 'disableCalculationAcknowledgement',
    label: t('laborRules.tipCreditCalculationModal.acknowledgementCheckbox', { action }),
    datatestid: isEnable
      ? 'enable-tip-credit-acknowledgement-checkbox-input'
      : 'disable-tip-credit-acknowledgement-checkbox-input',
    value: isEnable ? 'enableCalculationAcknowledgement' : 'disableCalculationAcknowledgement',
    readOnly: false,
    required: true,
    disabled: loading,
  };

  return (
    <LaborRuleBaseConfirmationModal
      dataTestId={`${mode}-tip-credit-confirmation-modal`}
      title={t('laborRules.tipCreditCalculationModal.title', { action })}
      subHeaderText={t(subHeaderTextKey)}
      ctaText={t('laborRules.tipCreditCalculationModal.ctaButtonText', { action })}
      loading={loading}
      handleClose={handleClose}
      ctaAction={handleAction}
      secondaryAcknowledgementCheckbox={acknowledgementCheckbox}
      dateEffectiveDateDefault={furthestAwayWorkWeekDate}
      ctaRed={!isEnable}
    />
  );
}
